export const DISCOVERY_TITLE_1 = "What best describes your role?";
export const DISCOVERY_TITLE_2 = "What are you interested in?";
export const DISCOVERY_SUBTITLE =
  "This will help us get you to the right place";

// Central config for DiscoveryFlow. Update option IDs or add links as needed.
const roles = [
  {
    id: "student",
    label: "I am a Student",
    icon: "/Icons/student-icon.svg",
    endAdornment: "radio",
  },
  {
    id: "parent",
    label: "I am a Parent / Guardian",
    icon: "/Icons/parent-icon.svg",
    endAdornment: "radio",
  },
  {
    id: "other",
    label: "Other",
    icon: "/Icons/other-icon.svg",
    endAdornment: "chevron",
  },
];

const optionWithRoles = {
  student: {
    title: DISCOVERY_TITLE_1,
    subtitle: DISCOVERY_SUBTITLE,
    options: [
      {
        id: "scholarships_fin_aid",
        label: "Scholarships & financial aid",
        // href: "/create_email",
        href: "/create_email",
      },
      {
        id: "academic_admissions",
        label: "Academic & Admissions Help",
        // href: "https://collegeaidpro.com/wake-me-when-its-over-plans-and-pricing/",
        href: "/create_email?from_discovery_page=true",
      },
      {
        id: "everything",
        label: "Everything",
        // href: "https://collegeaidpro.com/wake-me-when-its-over-plans-and-pricing/",
        href: "/create_email?from_discovery_page=true",
      },
      {
        id: "other",
        label: "Other",
        // href: "https://meetings.hubspot.com/college-aid-pro/free-20-min-consult?uuid=7530b3f4-a5f7-4197-93f9-30b2923686ae",
        href: "https://collegeaidpro.com/contact?from_discovery_page=true",

        // href: "/create_email?from_discovery_page=true",
      },
    ],
  },
  parent: {
    title: DISCOVERY_TITLE_1,
    subtitle: DISCOVERY_SUBTITLE,
    options: [
      {
        id: "scholarships_fin_aid",
        label: "Scholarships & financial aid",
        href: "/create_email",
      },
      {
        id: "academic_admissions",
        label: "Academic & Admissions Help",
        href: "https://collegeaidpro.com/wake-me-when-its-over-plans-and-pricing/",
      },
      {
        id: "everything",
        label: "Everything",
        href: "https://collegeaidpro.com/wake-me-when-its-over-plans-and-pricing/",
      },
      {
        id: "other",
        label: "Other",
        href: "https://meetings.hubspot.com/college-aid-pro/free-20-min-consult?uuid=7530b3f4-a5f7-4197-93f9-30b2923686ae",
      },
    ],
  },
  other: {
    title: DISCOVERY_TITLE_1,
    subtitle: DISCOVERY_SUBTITLE,
    options: [
      {
        id: "software",
        label: "MyCAP Software",
        href: "/create_email",
      },
      // {
      //   id: "wakeme",
      //   label: "Wake Me Packages",
      //   href: "https://collegeaidpro.com/wake-me-when-its-over-plans-and-pricing/",
      // },
      {
        id: "subscription",
        label: "+CAP Subscription",
        href: "https://buy.stripe.com/8x27sL8CPec2bzZgHlgQE28",
      },
      // {
      //   id: "talk",
      //   label: "Talk to Someone",
      //   href: "https://meetings.hubspot.com/college-aid-pro/free-20-min-consult?uuid=7530b3f4-a5f7-4197-93f9-30b2923686ae",
      // },
      {
        id: "other",
        label: "Other / Unsure",
        href: "https://collegeaidpro.com/contact?from_discovery_page=true",
      },
    ],
  },
};

const discoveryConfig = { roles, optionWithRoles };

// Function to get interest options based on sub-role
export const getInterestOptions = (subRole) => {
  switch (subRole) {
    case "hs_counselor":
      return [
        {
          id: "software",
          label: "MyCAP Software",
          href: "/create_email",
        },
        {
          id: "become_partner",
          label: "Become a CAP Partner School",
          href: "https://meetings.hubspot.com/mattc17/school-counselors?uuid=ef1e804a-821b-4eac-a9af-2f3aa7412ee3",
        },
        {
          id: "other",
          label: "Other / Unsure",
          href: "https://collegeaidpro.com/contact?from_discovery_page=true",
        },
      ];
    case "college_admin":
    case "cbo":
      return [
        {
          id: "software",
          label: "MyCAP Software",
          href: "/create_email",
        },
        {
          id: "become_partner",
          label: "Become a CAP Partner",
          href: "https://meetings.hubspot.com/mattc17/school-counselors?uuid=e8f8abbf-06fe-4adb-8594-21df6af80743",
        },
        {
          id: "other",
          label: "Other / Unsure",
          href: "https://collegeaidpro.com/contact?from_discovery_page=true",
        },
      ];
    default:
      // For other sub-roles, return empty array (they won't use this component)
      return [];
  }
};
export default discoveryConfig;
